var map = {
	"./en-US/categories.json": 67256,
	"./en-US/localization.json": 95580,
	"./ru-RU/categories.json": 6792,
	"./ru-RU/localization.json": 40752,
	"./sr-RS/categories.json": 60520,
	"./sr-RS/localization.json": 69160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74112;